import { render, staticRenderFns } from "./SystemTasks.vue?vue&type=template&id=37cb4261"
import script from "./SystemTasks.vue?vue&type=script&lang=js"
export * from "./SystemTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports